import { render, staticRenderFns } from "./CreateExpense.vue?vue&type=template&id=df720472"
import script from "./CreateExpense.vue?vue&type=script&lang=js"
export * from "./CreateExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports